/* Wellbell v2 interactions. Own code. ~3 KB, no dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = {}; try { cfg = JSON.parse(document.getElementById('wb-offers').textContent); } catch (e) {}
  var fmt = function (p) { return '\u20B9' + Math.round(p / 100).toLocaleString('en-IN'); };

  /* 1. Scroll-reveal for custom cards: reuse the theme's own scroll-trigger (animations.js), below the fold only. */
  if (!reduce && document.querySelector('script[src*="animations"]')) {
    var vh = window.innerHeight;
    document.querySelectorAll('.wb-steps__list, .wb-compare__card, .wb-coupons:not(.wb-coupons--pdp), .wb-head').forEach(function (group) {
      var items = group.classList.contains('wb-steps__list') ? group.children : [group];
      Array.prototype.forEach.call(items, function (el, i) {
        if (el.getBoundingClientRect().top < vh) return;
        el.classList.add('scroll-trigger', 'animate--slide-in');
        el.style.setProperty('--animation-order', i);
      });
    });
  }

  /* 2. Copy-code buttons. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wb-copy]'); if (!b) return;
    var code = b.getAttribute('data-wb-copy'), hint = b.querySelector('.wb-code__hint');
    var done = function () { b.classList.add('is-copied'); if (hint) hint.textContent = 'Copied'; setTimeout(function () { b.classList.remove('is-copied'); if (hint) hint.textContent = 'Copy'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* 3. Honest delivery estimate: dispatch within 24 h, 3–6 working days (Sundays skipped). */
  var addWorking = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; };
  var opt = { weekday: 'short', day: 'numeric', month: 'short' };
  document.querySelectorAll('[data-wb-eta]').forEach(function (el) {
    var now = new Date(), a = addWorking(now, 3), z = addWorking(now, 6);
    el.textContent = a.toLocaleDateString('en-IN', opt) + ' – ' + z.toLocaleDateString('en-IN', opt);
  });

  /* 4. Pack selector: drives the theme's own quantity input; only when the pack offer switch is on. */
  var packs = document.querySelector('[data-wb-packs]');
  var packPrice = {};
  if (packs && cfg.packs) {
    document.body.classList.add('wb-packs-on');
    packs.querySelectorAll('input[data-price]').forEach(function (r) { packPrice[r.value] = parseInt(r.getAttribute('data-price'), 10); });
    var pSection = packs.closest('.shopify-section') || document;
    var pQty = pSection.querySelector('input[name="quantity"]');
    var sticky = document.querySelector('.wb-sticky__now');
    var apply = function () {
      var r = packs.querySelector('input:checked'); if (!r) return;
      if (pQty) { pQty.value = r.value; pQty.dispatchEvent(new Event('change', { bubbles: true })); }
      if (sticky) sticky.textContent = fmt(packPrice[r.value]);
    };
    packs.addEventListener('change', apply); apply();
  }

  /* 4b. Benefit CTA "Start my nightly ritual → ₹X": live total for the chosen quantity.
     Pack prices come from the pack cards (2-bottle discount is once per order), otherwise unit × qty. */
  var ctaTotal = function (unit, q) {
    if (cfg.packs && packPrice['2'] && q >= 2) return unit * q - (unit * 2 - packPrice['2']);
    return unit * q;
  };
  document.querySelectorAll('.product-form__submit[data-wb-unit]').forEach(function (btn) {
    var unit = parseInt(btn.getAttribute('data-wb-unit'), 10), pre = btn.getAttribute('data-wb-label');
    var sec = btn.closest('.shopify-section') || document, q = sec.querySelector('input[name="quantity"]');
    var render = function () {
      var span = btn.querySelector('span'); if (!span || btn.disabled || !unit) return;
      var n = Math.max(1, parseInt(q && q.value, 10) || 1);
      span.textContent = pre + ' ' + fmt(ctaTotal(unit, n));
    };
    if (q) { q.addEventListener('change', render); q.addEventListener('input', render); }
    render();
  });

  /* 5. Add-to-cart feedback: tick state on the clicked button + cart icon bump. */
  var last = null;
  document.addEventListener('click', function (e) { var b = e.target.closest('.product-form__submit, .wb-sticky__btn'); if (b) last = b; }, true);
  var flash = function () {
    var els = [last, last && last.classList.contains('wb-sticky__btn') ? document.querySelector('.product-form__submit') : null];
    els.forEach(function (b) { if (!b) return; b.classList.add('wb-added'); setTimeout(function () { b.classList.remove('wb-added'); }, 1800); });
    var c = document.getElementById('cart-icon-bubble'); if (c) { c.classList.remove('wb-bump'); void c.offsetWidth; c.classList.add('wb-bump'); }
  };
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'product-form') flash(); });
    }
  });
})();
